import { useEffect } from "react";
import ChannelConnection from "../../js/connection/ChannelConnection";
import ClientOverlay from "./ClientOverlay";
import ReactDOM from "react-dom";
import ConnectionData from "../../js/connection/ConnectionData";

export default function SFULayoutOverlay({
    connection
}: {
    connection: ChannelConnection;
}) {
    useEffect(() => {
        function onScreenshotRequest(connectionData: ConnectionData): void {
            connection.messager
                .requestScreenshot(connectionData)
                .then((videoFrameData: VideoFrameData) => {
                    connection.events.notify("onscreenshot", {
                        connectionData,
                        videoFrameData
                    });
                })
                .catch((ex) => console.log(ex));
        }

        function onUploadClick(connectionData: ConnectionData): void {
            connection.events.notify("onscreenshot", {
                connectionData,
                videoFrameData: null
            });
        }

        function onFocusClick(connectionData: ConnectionData) {
            connection.toggleFocusView(connectionData.id);
        }

        function resize(datas: ConnectionData[]): void {
            for (const data of datas.filter(x => !!x.view)) {
                let el = data.view.querySelector("#overlay");
                if (!el) {
                    el = document.createElement("div");
                    el.id = "overlay";

                    data.view.appendChild(el);
                    
                    ReactDOM.render(
                        <ClientOverlay
                            connection={connection}
                            connectionData={data}
                            onScreenshotClick={onScreenshotRequest}
                            onUploadClick={onUploadClick}
                            // onFocusClick={onFocusClick}
                        />,
                        el
                    );
                }
            }
        }

        connection.events.addListener("onvideolayout", resize);

        return () => {
            connection.events.removeListener("onvideolayout", resize);
        };
    }, [connection]);

    return <></>;
}
